import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewModulo = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'modulo',
        name: 'Modulo',
        component: ViewModulo,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
